var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.47193 2H17.027C20.7431 2 22.9584 4.17 22.9482 7.81V16.19C22.9482 19.83 20.7329 22 17.0168 22H8.47193C4.75587 22 2.54053 19.83 2.54053 16.18V7.81C2.54053 4.17 4.75587 2 8.47193 2ZM16.5394 16.7729L12.7495 13.0606L8.9596 16.7729C8.66363 17.0628 8.17275 17.0628 7.87678 16.7729C7.5808 16.483 7.5808 16.0021 7.87678 15.7122L11.6667 11.9999L7.87678 8.28761C7.58081 7.9977 7.5808 7.51686 7.87678 7.22695C8.17275 6.93704 8.66363 6.93704 8.9596 7.22695L12.7495 10.9393L16.5394 7.22695C16.8353 6.93704 17.3262 6.93704 17.6222 7.22695C17.9182 7.51686 17.9182 7.9977 17.6222 8.28761L13.8323 11.9999L17.6222 15.7122C17.9182 16.0021 17.9182 16.483 17.6222 16.7729C17.3262 17.0628 16.8353 17.0628 16.5394 16.7729Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.226e3dfd539780ecdd7cb8b6fd15afb4.svg";
export { ForwardRef as ReactComponent };